import React from 'react';
import { Link } from 'react-router-dom';
export function LivoniaLinks() {
  return <section className="py-12 bg-subtle-gray/30 text-center" data-id="element-2403">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2404">
        <p className="text-gray-warm font-bold mb-4 uppercase tracking-wide" data-id="element-2405">
          Also Serving Nearby Communities
        </p>
        <div className="flex flex-wrap justify-center gap-4" data-id="element-2406">
          {['Farmington', 'Farmington Hills', 'Redford', 'Plymouth'].map((area, idx) => <Link key={idx} to={`/${area.toLowerCase().replace(/\s+/g, '-')}-martial-arts`} className="text-ink hover:text-storm-red transition-colors font-medium" data-id="element-2407">
                {area}
              </Link>)}
        </div>
      </div>
    </section>;
}